export default "/images/feeding_environment_sm.jpg?346ac8c85e467c9c71df67ebf2caa283";